import { StatusEnum } from "./status-enum";

export const statusLabels = {
  [StatusEnum.PENDING]: "Pending",
  [StatusEnum.PARTIALLY_PROCESSED]: "Terproses Sebagian",
  [StatusEnum.FULLY_PROCESSED]: "Terproses Semua",
};
